module.exports = __webpack_public_path__ + "img/pragmatic-stream.c6af2e83.svg";